import React from "react";
import CookiePolicy from "../component/CookiePolicy";

function CookiePolicyContainer() {
  return <CookiePolicy></CookiePolicy>;
}

export default CookiePolicyContainer;
